import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed} from 'vue'

interface Props {
  width?: string
  height?: string
  radius?: string
  circle?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomLoading',
  props: {
    width: { default: '100%' },
    height: { default: '16px' },
    radius: { default: '14px' },
    circle: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const skeletonStyle = computed(() => ({
  width: props.width,
  height: props.height,
  borderRadius: props.circle ? '50%' : props.radius
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-cu-loading", { 'skeleton--circle': __props.circle }]),
    style: _normalizeStyle(skeletonStyle.value)
  }, null, 6))
}
}

})